<app-tab-toolbar [tabId]="'emissionsWaste'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges && !isCarriedForward" [showOtherMeasurement]="true" [otherMeasurement]="otherMeasurement" [showKeywordsToggle]="true" [keywordsVisible]="showKeywords" (keywordsVisibleChange)="showKeywords = $event" (yearChange)="onYearChange($event)" (otherMeasurementChange)="onOtherMeasurementChange($event)" (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>{{ isCarriedForward ? 'info' : 'warning' }}</mat-icon>
      @if (isCarriedForward) {
        <span>There is no data for the selected year. Some fields are shown from a previous year.</span>
      } @else {
        <span>There is no data for the selected year</span>
      }
    </div>
  }
</app-tab-toolbar>

<div class="ew-content" [formGroup]="form" [appReadOnlyTab]="'emissionsWaste'">

  <div class="main-layout">
  <div class="left-column">

    <!-- Emissions Section -->
    <div class="ew-section">
      <!-- Top emissions grid (Scope 1, 2, 3 total) -->
      <div class="emissions-grid">
        <!-- Title header -->
        <div class="ht-label"></div>
        <div class="ht-title-header" style="grid-column: span 5">Emissions</div>

        <!-- Column headers -->
        <div class="ht-label"></div>
        <div class="ht-col-header">Current Year</div>
        <div class="ht-col-header">Restatement</div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header">Current Year</div>
        <div class="ht-col-header">Restatement</div>

        <!-- Top rows -->
        @for (row of emissionsTopRows; track row.key) {
          <div class="ht-label">{{ row.label }}</div>
          <div class="ht-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key))">{{ formatNumber(getOtherValue(row.key)) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key + 'Restatement'" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key + 'Restatement'))">{{ formatNumber(getOtherValue(row.key + 'Restatement')) }}</span>}
          </div>
          <div class="ht-cell">
            <select [formControlName]="row.key + 'UnitId'" class="ht-select" [title]="getUnitName(form.get(row.key + 'UnitId')?.value)">
              <option value=""></option>
              @for (unit of emissionsUnits; track unit.id) {
                <option [value]="unit.id" [title]="unit.name">{{ unit.name }}</option>
              }
            </select>
            @if (otherMeasurement) {<span class="ht-other" [title]="getUnitName(getOtherStringValue(row.key + 'UnitId'))">{{ getUnitName(getOtherStringValue(row.key + 'UnitId')) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConverted(row.key))" readonly>
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key))">{{ formatNumber(getOtherConverted(row.key)) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConvertedRestatement(row.key))" readonly>
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key, 'Restatement'))">{{ formatNumber(getOtherConverted(row.key, 'Restatement')) }}</span>}
          </div>
        }
      </div>

      <!-- Scope 3 Details Expansion Panel -->
      <mat-expansion-panel class="scope3-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>Scope 3 Details</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="scope3-detail-grid">
          <!-- Column headers -->
          <div class="s3-label"></div>
          <div class="s3-col-header">Current Year</div>
          <div class="s3-col-header">Restatement</div>

          @for (row of scope3DetailRows; track row.key) {
            <div class="s3-label">{{ row.label }}</div>
            <div class="ht-cell">
              <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key" class="ht-input">
              @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key))">{{ formatNumber(getOtherValue(row.key)) }}</span>}
            </div>
            <div class="ht-cell">
              <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key + 'Restatement'" class="ht-input">
              @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key + 'Restatement'))">{{ formatNumber(getOtherValue(row.key + 'Restatement')) }}</span>}
            </div>
          }

          <!-- Scope 3 total (read-only summary) -->
          <div class="s3-label">Scope 3</div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(form.get('scope3')?.value)" readonly>
          </div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(form.get('scope3Restatement')?.value)" readonly>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Bottom emissions grid (Other GHG Emissions, Reduction & Pricing) -->
      <div class="emissions-grid emissions-grid-continuation">
        @for (row of emissionsBottomRows; track row.key) {
          <div class="ht-label">{{ row.label }}</div>
          <div class="ht-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key))">{{ formatNumber(getOtherValue(row.key)) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key + 'Restatement'" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key + 'Restatement'))">{{ formatNumber(getOtherValue(row.key + 'Restatement')) }}</span>}
          </div>
          <div class="ht-cell">
            <select [formControlName]="row.key + 'UnitId'" class="ht-select" [title]="getUnitName(form.get(row.key + 'UnitId')?.value)">
              <option value=""></option>
              @for (unit of (row.key === 'greenhouseGas' ? greenhouseGasUnits : emissionsUnits); track unit.id) {
                <option [value]="unit.id" [title]="unit.name">{{ unit.name }}</option>
              }
            </select>
            @if (otherMeasurement) {<span class="ht-other" [title]="getUnitName(getOtherStringValue(row.key + 'UnitId'))">{{ getUnitName(getOtherStringValue(row.key + 'UnitId')) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConverted(row.key))" readonly>
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key))">{{ formatNumber(getOtherConverted(row.key)) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConvertedRestatement(row.key))" readonly>
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key, 'Restatement'))">{{ formatNumber(getOtherConverted(row.key, 'Restatement')) }}</span>}
          </div>
        }
      </div>

      @if (showKeywords) {
        <div class="keywords-section" formGroupName="keywords">
          <div class="section-header"><span>Keywords</span></div>
          <div class="keywords-fields"><app-keyword-input name="emission" label="Emission" /></div>
        </div>
      }
    </div>

  </div>

  <div class="right-column">

    <!-- Waste Section -->
    <div class="ew-section">
      <div class="waste-pct-grid">
        <!-- Title header -->
        <div class="ht-label"></div>
        <div class="ht-title-header" style="grid-column: span 6">Waste</div>

        <!-- Column headers -->
        <div class="ht-label"></div>
        <div class="ht-col-header">Current Year</div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header">Restatement</div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header">Current Year</div>
        <div class="ht-col-header">Restatement</div>

        <!-- Waste rows -->
        @for (row of wasteRows; track row.key) {
          <div class="ht-label" [class.ht-indent]="row.indent">{{ row.label }}</div>
          <div class="ht-cell">
            <input type="text" [attr.inputmode]="row.isPct ? 'decimal' : 'numeric'" appNumberFormat [min]="row.isPct ? 0 : null" [max]="row.isPct ? 100 : null" [decimals]="row.isPct ? 2 : null" [formControlName]="row.key" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key))">{{ formatNumber(getOtherValue(row.key)) }}</span>}
          </div>
          <div class="ht-cell">
            @if (row.showPct) {
              <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" [formControlName]="row.key + 'Pct'" class="ht-input" placeholder="%">
            }
          </div>
          <div class="ht-cell">
            <input type="text" [attr.inputmode]="row.isPct ? 'decimal' : 'numeric'" appNumberFormat [min]="row.isPct ? 0 : null" [max]="row.isPct ? 100 : null" [decimals]="row.isPct ? 2 : null" [formControlName]="row.key + 'Restatement'" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key + 'Restatement'))">{{ formatNumber(getOtherValue(row.key + 'Restatement')) }}</span>}
          </div>
          <div class="ht-cell">
            @if (row.noUnit) {
              <!-- No unit for this field -->
            } @else if (row.useCurrency) {
              <select [formControlName]="row.key + 'CurrencyId'" class="ht-select" [title]="getCurrencyName(form.get(row.key + 'CurrencyId')?.value)">
                <option value=""></option>
                @for (currency of currencies; track currency.id) {
                  <option [value]="currency.id" [title]="currency.name">{{ currency.name }}</option>
                }
              </select>
              @if (otherMeasurement) {<span class="ht-other" [title]="getCurrencyName(getOtherStringValue(row.key + 'CurrencyId'))">{{ getCurrencyName(getOtherStringValue(row.key + 'CurrencyId')) }}</span>}
            } @else {
              <select [formControlName]="row.key + 'UnitId'" class="ht-select" [title]="getUnitName(form.get(row.key + 'UnitId')?.value)">
                <option value=""></option>
                @for (unit of wasteUnits; track unit.id) {
                  <option [value]="unit.id" [title]="unit.name">{{ unit.name }}</option>
                }
              </select>
              @if (otherMeasurement) {<span class="ht-other" [title]="getUnitName(getOtherStringValue(row.key + 'UnitId'))">{{ getUnitName(getOtherStringValue(row.key + 'UnitId')) }}</span>}
            }
          </div>
          <div class="ht-cell">
            @if (!row.noUnit && !row.useCurrency) {
              <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConverted(row.key))" readonly>
              @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key))">{{ formatNumber(getOtherConverted(row.key)) }}</span>}
            }
          </div>
          <div class="ht-cell">
            @if (!row.noUnit && !row.useCurrency) {
              <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConvertedRestatement(row.key))" readonly>
              @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key, 'Restatement'))">{{ formatNumber(getOtherConverted(row.key, 'Restatement')) }}</span>}
            }
          </div>
        }
      </div>

      @if (showKeywords) {
        <div class="keywords-section" formGroupName="keywords">
          <div class="section-header"><span>Keywords</span></div>
          <div class="keywords-fields"><app-keyword-input name="waste" label="Waste" /></div>
        </div>
      }
    </div>

    <!-- Environmental Compliance Section -->
    <div class="ew-section">
      <div class="waste-grid">
        <!-- Title header -->
        <div class="ht-label"></div>
        <div class="ht-title-header" style="grid-column: span 5">Environmental Compliance</div>

        <!-- Column headers -->
        <div class="ht-label"></div>
        <div class="ht-col-header">Current Year</div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header"></div>

        @for (row of environmentalRows; track row.key) {
          <div class="ht-label">{{ row.label }}</div>
          <div class="ht-cell" style="grid-column: span 2">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key))">{{ formatNumber(getOtherValue(row.key)) }}</span>}
          </div>
          <div class="ht-cell" style="grid-column: span 3">
            <select [formControlName]="row.key + 'CurrencyId'" class="ht-select" [title]="getCurrencyName(form.get(row.key + 'CurrencyId')?.value)">
              <option value=""></option>
              @for (currency of currencies; track currency.id) {
                <option [value]="currency.id" [title]="currency.name">{{ currency.name }}</option>
              }
            </select>
            @if (otherMeasurement) {<span class="ht-other" [title]="getCurrencyName(getOtherStringValue(row.key + 'CurrencyId'))">{{ getCurrencyName(getOtherStringValue(row.key + 'CurrencyId')) }}</span>}
          </div>
        }
      </div>

      @if (showKeywords) {
        <div class="keywords-section" formGroupName="keywords">
          <div class="section-header"><span>Keywords</span></div>
          <div class="keywords-fields"><app-keyword-input name="environmentalCompliance" label="Environmental Compliance" /></div>
        </div>
      }
    </div>

  </div>
  </div>

  <!-- Comments -->
  <section class="section-container nrg-border-radius-second-level">
    <div class="section-header">
      <span>Comments</span>
    </div>
    <div class="section-content">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="5"></textarea>
      </mat-form-field>
      @if (otherMeasurement && otherData?.comments) {
        <div class="comparison-hint">{{ otherData!.comments }}</div>
      }
    </div>
  </section>

</div>
